import React from "react";
import { ApplicationApi, StatusResponse } from "../../lib-api";
import ApplicationContainer from "../applicationContainer";
import ApplicationContent from "../applicationContent";
import TopStripIndicator from "./topStripIndicator";

interface Props {
  data: StatusResponse;
}

const ApplicationManual: React.FunctionComponent<Props> = props => {
  return (
    <ApplicationContainer>
      <TopStripIndicator />
      <ApplicationContent>
        <h2 className="text-primary">Manuel behandling</h2>
        <div className="text-center py-5">
          <p>Din ansøgning er blevet sendt videre til manuel behandling.</p>
          <p>Basisbank vil kontakte hurtigst muligt</p>
        </div>
        <div className="text-center pb-5">
                  <a href="/" className="btn whiteButton btn-primary py-3 px-5">
            Til forside
          </a>
        </div>
      </ApplicationContent>
    </ApplicationContainer>
  );
};

export default ApplicationManual;
